module.exports = __webpack_public_path__ + "static/media/desvelao-bg.40edb4a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/desvelao-bg.jpg
// module id = 319
// module chunks = 0